// passwordValidations.js
import { helpers } from '@vuelidate/validators'
const { withMessage, regex } = helpers

// Helper functions
const hasRepeatingChars = (str) => /(.)\1{2,}/.test(str)

const hasNumericSequence = (str) => {
  for (let i = 0; i < str.length - 2; i++) {
    const slice = str.slice(i, i + 3)
    if (/^\d+$/.test(slice)) {
      const nums = slice.split('').map(Number)
      if (
        (nums[1] === nums[0] + 1 && nums[2] === nums[1] + 1) ||
        (nums[1] === nums[0] - 1 && nums[2] === nums[1] - 1)
      ) {
        return true
      }
    }
  }
  return false
}

const hasCharacterSequence = (str) => {
  const lowercaseStr = str.toLowerCase()
  for (let i = 0; i < str.length - 3; i++) {
    const slice = lowercaseStr.slice(i, i + 4)
    if (/^[a-z]+$/.test(slice)) {
      let isSequential = true
      for (let j = 1; j < slice.length; j++) {
        if (slice.charCodeAt(j) !== slice.charCodeAt(j - 1) + 1) {
          isSequential = false
          break
        }
      }
      if (isSequential) return true
    }
    if (slice.length === 4 && slice.slice(0, 2) === slice.slice(2)) {
      return true
    }
  }
  return false
}

const isNotCommonPassword = (value) => {
    const commonPasswords = [
        'qwertyuiop', '1234567890', 'q1w2e3r4t5', '1q2w3e4r5t', '4815162342', '12345qwert',
        '123456789a', '1234554321', 'Usuckballz1', '1111111111', '123456789q', '1029384756',
        'password123', 'basketball', 'Soso123aljg', '123qweasdzxc', '12345678910', 'manchester',
        '1qaz2wsx3edc', 'q1w2e3r4t5y6', '1123581321', '1q2w3e4r5t6y', 'qwerty12345', '1234512345',
        'Mailcreated5240', '1122334455', 'nuttertools', 'qazwsxedcrfv', 'fuck_inside', '123456qwerty',
        '1234567890q', 'qwerty123456', '5555555555', 'terminator', '9876543210', 'california',
        'enterprise', 'rjirfrgbde', '123456789z', 'poiuytrewq', 'Sojdlg123aljg', 'Translator',
        'fktrcfylhf', 'deepthroat', 'multiplelo', 'christopher', 'undertaker', 'a123456789',
        'motherlode', 'sersolution', 'qwerty1234', 'montgom240', 'salamander', 'qwertyqwerty',
        '1.23457E+11', 'syncmaster', 'aleksandra', 'rjycnfynby', 'tinkerbell', 'motherfucker',
        'ghostrider', 'realmadrid', 'PolniyPizdec0211', '1357924680', '7uGd5HIp2J', 'playstation',
        'leavemealone', 'dragonball', '1234567890a', 'microphone', 'gfhjkmgfhjkm', '1234567891',
        'vSjasnel12', 'strawberry', 'washington', '9293709b13', 'yjdsqgfhjkm', 'qazwsxedc123',
        'fuckinside', 'Good123654', '7894561230', 'harrypotter', 'zxcvbnm123', 'mypassword',
        'alessandro', 'abrakadabra', '7777777777', '123456789s', 'underground', 'ghjcnjgfhjkm',
        'password12', 'anastasiya', 'zxcasdqwe123', 'qwert12345', 'pufunga7782', 'highlander',
        'ghhh47hj7649', 'Password123', 'konstantin', 'intercourse', '9999999999', '2222222222',
        '3333333333', '4444444444', '6666666666', '8888888888', '0'
    ];
    return !commonPasswords.includes(value);
}

// Custom validators
const noRepeatingChars = (value) => !hasRepeatingChars(value)
const noNumericSequence = (value) => !hasNumericSequence(value)
const noCharacterSequence = (value) => !hasCharacterSequence(value)

export const passwordValidations = {
    minLength: withMessage(
        'Password must be at least 12 characters long',
        (value) => value?.length >= 12
    ),
    uppercase: withMessage(
        'Password must contain at least 1 uppercase letter',
        regex(/[A-Z]+/)
    ),
    lowercase: withMessage(
        'Password must contain at least 1 lowercase letter',
        regex(/[a-z]+/)
    ),
    number: withMessage(
        'Password must contain at least 1 number',
        regex(/\d+/)
    ),
    symbol: withMessage(
        'Password must contain at least 1 symbol',
        regex(/[!@#$%^&*(),.?":{}|<>]/)
    ),
    noRepeatingChars: withMessage(
        'Password cannot contain characters repeated more than twice in a row',
        noRepeatingChars
    ),
    noNumericSequence: withMessage(
        'Password cannot contain ordered numeric sequences (like 123 or 321)',
        noNumericSequence
    ),
    noCharacterSequence: withMessage(
        'Password cannot contain ordered character sequences (like abcd) or patterns (like abab)',
        noCharacterSequence
    ),
    notCommon: withMessage('The password you entered is too common and can be easily guessed. Please choose a more secure password to increase your account\'s safety', isNotCommonPassword),
}